.root {
  display: flex;
  gap: 1.5rem;
  /* The package ships no global font; buttons/spans below would otherwise fall back to the
     UA serif. Anchor the whole grid on Inter and let the controls inherit it. */
  font-family: var(--font-family-base);
}
.nav,
.day {
  font-family: inherit;
}

.month {
  display: flex;
  flex-direction: column;
}
/* Two-month view (Figma "Date range menu"): each month is a full-height column carrying its own
   padding, so the divider on the second column's left edge runs the full card height — top to
   footer border — rather than only spanning the grid. */
.multi {
  gap: 0;
}
.multi .month {
  padding: 1.25rem 1.5rem;
}
.multi .month:not(:first-child) {
  border-left: 1px solid var(--border-light);
}

/* ── Header (nav + title) ── */
.header {
  display: grid;
  grid-template-columns: 2rem 1fr 2rem;
  align-items: center;
  margin-bottom: 0.5rem;
}
.title {
  text-align: center;
  color: var(--text-secondary);
}
.belowHeader {
  width: 100%;
  margin-bottom: 0.75rem;
}
.nav {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background 150ms ease;
}
.nav:hover {
  background: var(--surface-hover);
}
.nav:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}
.navSpacer {
  width: 2rem;
  height: 2rem;
}

/* ── Weekday header + weeks ── */
.weekdays,
.week {
  display: grid;
  grid-template-columns: repeat(7, 2.5rem);
}
.weekday {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.25rem;
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
}

/* ── Day cell + range track ── */
.cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
}
.inRange {
  background: var(--surface-secondary);
}
.rangeStart {
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
}
.rangeEnd {
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
}

.day {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.875rem;
  line-height: 1.25rem;
  cursor: pointer;
  transition: background 150ms ease;
}
.day:hover:not(:disabled) {
  background: var(--surface-hover);
}
.day:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring);
}
.day:disabled {
  color: var(--text-disabled);
  cursor: default;
}
.outside {
  color: var(--text-quaternary);
}
.today:not(.selected) {
  font-weight: 500;
  color: var(--text-primary);
  background: var(--surface-secondary);
}
.day.selected {
  background: var(--brand-solid);
  color: var(--fg-white);
  font-weight: 500;
}
/* Outrank `.day:hover:not(:disabled)` (0,3,0) so the selected day keeps its brand fill on hover
   instead of falling back to the grey surface-hover with now-invisible white text. */
.day.selected:hover:not(:disabled) {
  background: var(--brand-solid-hover);
  color: var(--fg-white);
}

.dayNumber {
  display: block;
}
.dot {
  position: absolute;
  bottom: 0.25rem;
  left: 50%;
  width: 0.3125rem;
  height: 0.3125rem;
  transform: translateX(-50%);
  border-radius: 50%;
  background: var(--brand-solid);
}
.selected .dot {
  background: var(--fg-white);
}

@media (forced-colors: active) {
  .selected {
    background: Highlight;
    color: HighlightText;
  }
  .today:not(.selected) {
    box-shadow: inset 0 0 0 1px CanvasText;
  }
  .inRange {
    background: Canvas;
    border: 1px solid CanvasText;
  }
}
